import { render, staticRenderFns } from "./LangWizard.vue?vue&type=template&id=8ba0f83c"
import script from "./LangWizard.vue?vue&type=script&lang=js"
export * from "./LangWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports